import { BrainstormActionTypes } from './../action/index';
import { BrainstormState, initialState } from "../state/BrainstormState";
import { BrainstormActions } from "../action/BrainstormActions";

export function brainstormReducer(state: BrainstormState = initialState, action: BrainstormActions): BrainstormState {
    switch (action.type) {
        case BrainstormActionTypes.CLEAR:
            return {...state, 
                loadingListBranches: false,
                errorListBranches: false,
                branchesData: null,
                loadingListDepartments: false,
                errorListDepartments: false,
                departmentsData: null,
                loadingListCollaborators: false,
                errorListCollaborators: false,
                collaboratorsData: null,
                loadingGetCollaborator: false,
                errorGetCollaborator: false,
                collaboratorData: null,
                loadingGetIdea: false,
                errorGetIdea: false,
                ideaData: null,
                loadingSaveIdea: false,
                errorSaveIdea: false ,
                savedIdeaData: null
            };
        case BrainstormActionTypes.LIST_BRANCHES:
            return {...state, loadingListBranches: true, errorListBranches: false, branchesData: null };
        case BrainstormActionTypes.LIST_BRANCHES_SUCCESS:
            return {...state, loadingListBranches: false, errorListBranches: false, branchesData: action.branchesData };
        case BrainstormActionTypes.LIST_BRANCHES_ERROR:
            return {...state, loadingListBranches: false, errorListBranches: true, branchesData: null };
        case BrainstormActionTypes.LIST_DEPARTMENTS:
            return {...state, loadingListDepartments: true, errorListDepartments: false, departmentsData: null };
        case BrainstormActionTypes.LIST_DEPARTMENTS_SUCCESS:
            return {...state, loadingListDepartments: false, errorListDepartments: false, departmentsData: action.departmentsData };
        case BrainstormActionTypes.LIST_DEPARTMENTS_ERROR:
            return {...state, loadingListDepartments: false, errorListDepartments: true, departmentsData: null };
        case BrainstormActionTypes.LIST_COLLABORATORS:
            return {...state, loadingListCollaborators: true, errorListCollaborators: false, collaboratorsData: null };
        case BrainstormActionTypes.LIST_COLLABORATORS_SUCCESS:
            return {...state, loadingListCollaborators: false, errorListCollaborators: false, collaboratorsData: action.collaboratorsData };
        case BrainstormActionTypes.LIST_COLLABORATORS_ERROR:
            return {...state, loadingListCollaborators: false, errorListCollaborators: true, collaboratorsData: null };
        case BrainstormActionTypes.GET_COLLABORATOR:
            return {...state, loadingGetCollaborator: true, errorGetCollaborator: false, collaboratorData: null };
        case BrainstormActionTypes.GET_COLLABORATOR_SUCCESS:
            return {...state, loadingGetCollaborator: false, errorGetCollaborator: false, collaboratorData: action.collaboratorData };
        case BrainstormActionTypes.GET_COLLABORATOR_ERROR:
            return {...state, loadingGetCollaborator: false, errorGetCollaborator: true, collaboratorData: null };
        case BrainstormActionTypes.LIST_IDEAS_IMPLEMENTER:
            return {...state, loadingListImplementerIdeas: true, errorListImplementerIdeas: false, implementerIdeasData: null };
        case BrainstormActionTypes.LIST_IDEAS_IMPLEMENTER_SUCCESS:
            return {...state, loadingListImplementerIdeas: false, errorListImplementerIdeas: false, implementerIdeasData: action.implementerIdeasData };
        case BrainstormActionTypes.LIST_IDEAS_IMPLEMENTER_ERROR:
            return {...state, loadingListImplementerIdeas: false, errorListImplementerIdeas: true, implementerIdeasData: null };
        case BrainstormActionTypes.LIST_IDEAS_COLLABORATOR:
            return {...state, loadingListCollaboratorIdeas: true, errorListCollaboratorIdeas: false, collaboratorIdeasData: null };
        case BrainstormActionTypes.LIST_IDEAS_COLLABORATOR_SUCCESS:
            return {...state, loadingListCollaboratorIdeas: false, errorListCollaboratorIdeas: false, collaboratorIdeasData: action.collaboratorIdeasData };
        case BrainstormActionTypes.LIST_IDEAS_COLLABORATOR_ERROR:
            return {...state, loadingListCollaboratorIdeas: false, errorListCollaboratorIdeas: true, collaboratorIdeasData: null };
        case BrainstormActionTypes.GET_IDEA:
            return {...state, loadingGetIdea: true, errorGetIdea: false, ideaData: null };
        case BrainstormActionTypes.GET_IDEA_SUCCESS:
            return {...state, loadingGetIdea: false, errorGetIdea: false, ideaData: action.ideaData };
        case BrainstormActionTypes.GET_IDEA_ERROR:
            return {...state, loadingGetIdea: false, errorGetIdea: true, ideaData: null };
        case BrainstormActionTypes.SAVE_IDEA:
            return {...state, loadingSaveIdea: true, errorSaveIdea: false };
        case BrainstormActionTypes.SAVE_IDEA_SUCCESS:
            return {...state, loadingSaveIdea: false, errorSaveIdea: false, savedIdeaData: action.ideaData };
        case BrainstormActionTypes.SAVE_IDEA_ERROR:
            return {...state, loadingSaveIdea: false, errorSaveIdea: true };
        case BrainstormActionTypes.CLEAR_ERRORS:
            return {...state, 
                loadingListBranches: false,
                errorListBranches: false,
                loadingListDepartments: false,
                errorListDepartments: false,
                loadingListCollaborators: false,
                errorListCollaborators: false,
                loadingGetCollaborator: false,
                errorGetCollaborator: false,
                loadingListImplementerIdeas: false,
                errorListImplementerIdeas: false,
                loadingListCollaboratorIdeas: false,
                errorListCollaboratorIdeas: false,
                loadingGetIdea: false,
                errorGetIdea: false,
                loadingSaveIdea: false,
                errorSaveIdea: false
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducer/BrainstormReducer.ts